export default function OptionItem({list}) {
	return list.map((item, key) => {
		return (
			<li className="options__item" key={key}>
				{item.icon ? <i className={item.icon} /> : <></>}
				
				<div className="options__content">
					<h4>{item.title}</h4>
					<p>{item.description}</p>
				</div>
			</li>
		);
	});
}
